import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import "./Head.css";

const Head = () => {
  return (
    <div className="head container-fluid">
      <div className="row align-items-center">
        <div className="col-12 col-md-6 text-center text-md-start">
          <p className="mb-1">tuvan247@memevietnam.com</p>
        </div>
        <div className="col-12 col-md-6 text-center text-md-end d-flex justify-content-center justify-content-md-end gap-2">
          <FontAwesomeIcon icon={faPhone} />
          <p className="mb-1">Hotline: 0916.23.86.23</p>
        </div>
      </div>
    </div>
  );
};

export default Head;
